export function setAdvancedSearchOption (state, value) {
  state.searchOption = value
}
